import classNames from 'classnames'

import { EntityPhaseList } from '../../Entity'
import { FormFieldContainer } from '../../Form'
import { LoaderText } from '../../LoaderText'
import Text from '../../Text'
import {
  getRequestPhaseStatusText,
  getTooltipAdditionalText,
} from '../Request.utils'

import * as styles from './RequestPhaseInput.module.css'

function RequestPhaseInput({
  disabled,
  error,
  isLoading,
  items,
  placeholder,
  tooltip,
  tooltipPlacement,
  value,
  onChange,
  ...restProps
}) {
  function handleClick(item) {
    onChange?.(item)
  }

  return (
    <FormFieldContainer
      disabled={!isLoading && (!items || items.length === 0)}
      error={error}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
    >
      {isLoading ? (
        <LoaderText className={styles.loading} />
      ) : !value && !items ? (
        <Text className={styles.placeholder}>{placeholder}</Text>
      ) : (
        <EntityPhaseList
          {...restProps}
          disabled={disabled}
          getPhaseStatusText={getRequestPhaseStatusText}
          getTooltipAdditionalText={getTooltipAdditionalText}
          items={items}
          phaseItemClassName={classNames(styles.phaseItem, {
            [styles.disabled]: disabled,
          })}
          value={value}
          onClick={handleClick}
        />
      )}
    </FormFieldContainer>
  )
}

export default RequestPhaseInput
